import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CardManage from '@/views/marketing/marketingManage/cardManage/index.vue'


const __default__ = { name: 'DcCosLbuCardManage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const permission = {
  add: 'lbu_card_add_btn',
  edit: 'lbu_card_edit_btn',
  del: 'lbu_card_del_btn',
  qrcode: 'lbu_card_qrcode_btn'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CardManage, {
    permission: permission,
    subdomain: "lbu"
  }))
}
}

})